<div class="legal-page">
  <div class="legal-container">
    <div class="legal-header">
      <h1>{{ 'privacyPolicy.title' | translate }}</h1>
      <p class="last-updated">{{ 'legal.lastUpdated' | translate }}: {{ lastUpdated }}</p>
    </div>

    <div class="legal-content">
      <h2>{{ 'privacyPolicy.section1.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section1.content' | translate }}</p>

      <div class="highlight-box">
        <p>
          <strong>{{ 'privacyPolicy.section1.summaryLabel' | translate }}:</strong> {{ 'privacyPolicy.section1.summaryText' | translate }}
        </p>
      </div>

      <h2>{{ 'privacyPolicy.section2.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section2.intro' | translate }}</p>
      <ul>
        <li><strong>{{ 'privacyPolicy.section2.accountInfo' | translate }}:</strong> {{ 'privacyPolicy.section2.accountInfoDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section2.profileInfo' | translate }}:</strong> {{ 'privacyPolicy.section2.profileInfoDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section2.horseInfo' | translate }}:</strong> {{ 'privacyPolicy.section2.horseInfoDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section2.eventData' | translate }}:</strong> {{ 'privacyPolicy.section2.eventDataDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section2.paymentInfo' | translate }}:</strong> {{ 'privacyPolicy.section2.paymentInfoDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section2.communications' | translate }}:</strong> {{ 'privacyPolicy.section2.communicationsDesc' | translate }}</li>
      </ul>

      <h2>{{ 'privacyPolicy.section3.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section3.intro' | translate }}</p>
      <ul>
        <li>{{ 'privacyPolicy.section3.item1' | translate }}</li>
        <li>{{ 'privacyPolicy.section3.item2' | translate }}</li>
        <li>{{ 'privacyPolicy.section3.item3' | translate }}</li>
        <li>{{ 'privacyPolicy.section3.item4' | translate }}</li>
        <li>{{ 'privacyPolicy.section3.item5' | translate }}</li>
        <li>{{ 'privacyPolicy.section3.item6' | translate }}</li>
        <li>{{ 'privacyPolicy.section3.item7' | translate }}</li>
      </ul>

      <h2>{{ 'privacyPolicy.section4.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section4.intro' | translate }}</p>
      <ul>
        <li><strong>{{ 'privacyPolicy.section4.eventOrganizers' | translate }}:</strong> {{ 'privacyPolicy.section4.eventOrganizersDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section4.ridingClubs' | translate }}:</strong> {{ 'privacyPolicy.section4.ridingClubsDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section4.serviceProviders' | translate }}:</strong> {{ 'privacyPolicy.section4.serviceProvidersDesc' | translate }}</li>
        <li><strong>{{ 'privacyPolicy.section4.legalRequirements' | translate }}:</strong> {{ 'privacyPolicy.section4.legalRequirementsDesc' | translate }}</li>
      </ul>

      <h2>{{ 'privacyPolicy.section5.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section5.content' | translate }}</p>

      <h2>{{ 'privacyPolicy.section6.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section6.intro' | translate }}</p>
      <ul>
        <li>{{ 'privacyPolicy.section6.item1' | translate }}</li>
        <li>{{ 'privacyPolicy.section6.item2' | translate }}</li>
        <li>{{ 'privacyPolicy.section6.item3' | translate }}</li>
        <li>{{ 'privacyPolicy.section6.item4' | translate }}</li>
        <li>{{ 'privacyPolicy.section6.item5' | translate }}</li>
        <li>{{ 'privacyPolicy.section6.item6' | translate }}</li>
      </ul>

      <h2>{{ 'privacyPolicy.section7.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section7.content' | translate }}</p>

      <h2>{{ 'privacyPolicy.section8.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section8.content' | translate }}</p>

      <h2>{{ 'privacyPolicy.section9.title' | translate }}</h2>
      <p>{{ 'privacyPolicy.section9.content' | translate }}</p>

      <div class="contact-info">
        <h3>{{ 'legal.contactUs' | translate }}</h3>
        <p>{{ 'privacyPolicy.contactIntro' | translate }}</p>
        <p>
          <strong>{{ 'legal.email' | translate }}:</strong> privacy&#64;horseloop.com<br>
          <strong>{{ 'legal.address' | translate }}:</strong> HorseLoop AS, Oslo, Norway
        </p>
      </div>
    </div>
  </div>
</div>
